export default "__VITE_ASSET__DTv7qKIu__"